import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { toast } from 'react-toastify';

const Contact = () => {
  // ✅ State for Form Data
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: ''
  });
  
  const [loading, setLoading] = useState(false);

  // 👇 Yahan wo Email likho jispar message chahiye
  const MY_EMAIL = "rajswad8@gmail.com"; 

  // ✅ Handle Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ Handle Submit (Send Email)
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if(!formData.firstName || !formData.email || !formData.message) {
        toast.error("Please fill all details!");
        return;
    }

    setLoading(true);

    try {
      // FormSubmit API Call
      const response = await fetch(`https://formsubmit.co/ajax/${MY_EMAIL}`, {
        method: "POST",
        headers: { 
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            name: `${formData.firstName} ${formData.lastName}`, // Naam jod kar bheje
            email: formData.email,
            message: formData.message,
            _subject: "New Message from KaamSetu App! 🚀",
            _template: "table"
        })
      });

      const result = await response.json();

      if (result.success === "true" || response.ok) {
        toast.success("Message Sent Successfully! ✅");
        setFormData({ firstName: '', lastName: '', email: '', message: '' }); // Reset Form
      } else {
        toast.error("Something went wrong. Try again.");
      }

    } catch (error) {
      console.error(error);
      toast.error("Internet connection check karein!");
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-slate-50 pt-24 pb-12 px-4">
      
      {/* HEADER SECTION */}
      <div className="text-center max-w-3xl mx-auto mb-12">
        <motion.h1 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-4xl font-extrabold text-slate-800 mb-4"
        >
          We're Here to Help 🤝
        </motion.h1>
        <p className="text-slate-500 text-lg">
          Have an issue with a worker? Or want to join as a partner? Drop us a message!
        </p>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10">
        
        {/* LEFT: CONTACT INFO CARD */}
        <motion.div 
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2 }}
          className="bg-gradient-to-br from-blue-600 to-indigo-700 rounded-3xl p-8 text-white shadow-2xl relative overflow-hidden"
        >
          {/* Background Decoration */}
          <div className="absolute top-0 right-0 w-40 h-40 bg-white opacity-10 rounded-full blur-3xl -mr-10 -mt-10"></div>
          
          <h3 className="text-2xl font-bold mb-6">Contact Information</h3>
          
          <div className="space-y-6">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center text-xl">📞</div>
              <div>
                <p className="text-blue-200 text-sm">Phone Number</p>
                <p className="font-bold text-lg">+91 9997898920</p>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center text-xl">📧</div>
              <div>
                <p className="text-blue-200 text-sm">Email Address</p>
                <p className="font-bold text-lg">{MY_EMAIL}</p>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center text-xl">📍</div>
              <div>
                <p className="text-blue-200 text-sm">Head Office</p>
                <p className="font-bold text-lg">Agra, UP</p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* RIGHT: MESSAGE FORM */}
        <motion.div 
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.4 }}
          className="bg-white rounded-3xl p-8 shadow-xl border border-slate-100"
        >
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm font-bold text-slate-700 mb-1">First Name</label>
                <input 
                  type="text" 
                  name="firstName" 
                  value={formData.firstName}
                  onChange={handleChange}
                  className="w-full p-3 bg-slate-50 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500" 
                  placeholder="Rohan" 
                />
              </div>
              <div>
                <label className="block text-sm font-bold text-slate-700 mb-1">Last Name</label>
                <input 
                  type="text" 
                  name="lastName" 
                  value={formData.lastName}
                  onChange={handleChange}
                  className="w-full p-3 bg-slate-50 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500" 
                  placeholder="Sharma" 
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-bold text-slate-700 mb-1">Email</label>
              <input 
                type="email" 
                name="email" 
                value={formData.email}
                onChange={handleChange}
                className="w-full p-3 bg-slate-50 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500" 
                placeholder="rohan@example.com" 
              />
            </div>

            <div className="mb-6">
              <label className="block text-sm font-bold text-slate-700 mb-1">Message</label>
              <textarea 
                name="message" 
                value={formData.message}
                onChange={handleChange}
                className="w-full p-3 bg-slate-50 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 h-32" 
                placeholder="How can we help you?"
              ></textarea>
            </div>

            <button 
              type="submit" 
              disabled={loading}
              className="w-full bg-slate-900 text-white py-4 rounded-xl font-bold hover:bg-blue-700 transition shadow-lg disabled:bg-slate-400"
            >
              {loading ? "Sending..." : "Send Message 🚀"}
            </button>
          </form>
        </motion.div>

      </div>
    </div>
  );
};

export default Contact;